import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import trackEvent from '~/modules/trackEvent';
import MediaQuery from '~/mixins/GetMediaQuery';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-left-doodle.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-right-doodle.svg';

var ProductItem = () => import('~/components/library/Product/ProductItem.vue');

export default {
  name: 'ProductsCarousel',
  components: {
    ProductItem
  },
  props: {
    products: {
      type: Array,
      required: true
    },
    reference: {
      type: String,
      default: null
    },
    isEarlyBirds: {
      type: Boolean,
      default: false
    },
    isShopTheLook: {
      type: Boolean,
      default: false
    },
    crossType: {
      type: String,
      default: null
    },
    disableTracking: {
      type: Boolean,
      default: false
    },
    lazySeo: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      carousel: 'div',
      slide: 'div'
    };
  },

  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    tracking: 'sharedEnv/tracking'
  })), {}, {
    productsCarouselCenter() {
      var numberOfProduct = this.products.length;

      if (MediaQuery.methods.isDesktop() && numberOfProduct < 4) {
        return 'center-earlybirds-items';
      }

      if (MediaQuery.methods.isTablet() && numberOfProduct < 3) {
        return 'center-earlybirds-items';
      }

      if (MediaQuery.methods.isMobile() && numberOfProduct < 2) {
        return 'center-earlybirds-items';
      }

      return null;
    }

  }),

  mounted() {
    this.carousel = 'mdm-carousel';
    this.slide = 'mdm-slide';
  },

  methods: {
    paginate(step) {
      var {
        carousel
      } = this.$refs;

      if (!carousel) {
        return;
      }

      var page = step === 'prev' ? carousel.getPreviousPage() : carousel.getNextPage();
      carousel.goToPage(page);
    },

    paginateTracking(page) {
      if (this.disableTracking) return;
      if (!this.isEarlyBirds) return;
      this.$root.$emit('generic-tracking', null, {
        fn: 'track-event',
        data: {
          event_category: 'FicheProduit',
          event_action: 'Button_Xsell_EB',
          event_label: "".concat(page)
        }
      });
    },

    clickTracking(evt, reference, breadcrumb) {
      if (this.disableTracking) return;

      if (this.isShopTheLook) {
        var payload = {
          data: {
            event_category: 'FicheProduit',
            event_action: 'Clic_Xsell_STL',
            event_label: "".concat(window.tc_vars.page_cat3, "_").concat(window.tc_vars.product_id)
          }
        };
        trackEvent({
          el: evt,
          payload,
          id: this.tracking.id,
          isCookieDebug: this.$nuxt.$cookies.get('debugmdm')
        });
      } else if (this.isEarlyBirds) {
        var cat3 = breadcrumb.slice(1, 4).pop();
        this.$root.$emit('generic-tracking', evt, {
          fn: 'track-event',
          data: {
            event_category: 'FicheProduit',
            event_action: this.crossType === 'similar' ? 'Clic_Xsell_EB' : 'Clic_Xsell_EB_complementary',
            event_label: "".concat(window.tc_vars.page_cat3, "_").concat(this.reference, "/").concat(cat3.name, "_").concat(reference)
          }
        });
      }
    }

  }
};